import React from 'react';
import './logo.css';

export class Logo extends React.Component
{
    render() {
      return (
        <div className="logo-header">
            <img src="/apple-touch-icon-57x57.png" alt="tigercity logo"/>
            <span className="logo">TigerCity.ai</span>
        </div>
        );
    }
};

